module.exports = "<hybse-admin-adduser [actionType]=\"'edit'\" [userType]=\"'Issuer'\">\n\n</hybse-admin-adduser>"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/users/issuers/edit-user/edit-user.component.html
// module id = ../../../../../src/app/components/pages/users/issuers/edit-user/edit-user.component.html
// module chunks = main